import styled from 'styled-components'
import { media, colors, truncate } from 'styles'
import Icon from 'components/Icon/StyledIcon'

const StyledUserProfile = styled.div`
  color: ${colors.textMain};

  .group-title {
    flex: 100%;
    font-size: 1.6rem;
    margin: 0.5rem 0 2rem;
  }
  .left {
    padding-right: 2rem;
  }
  .right {
    padding-left: 2rem;
  }
  .top {
    margin-bottom: 10rem;
  }
  .value:empty::before {
    content: '-';
  }
  .half {
    max-width: calc(50% - 2rem);
  }
  .row {
    display: flex;
    margin: 0;
    margin-bottom: 1.4rem;
    font-size: 1.4rem;
  }
  .category {
    min-width: calc(25% - 0.5rem);
    color: ${colors.textSecondary};
    font-weight: 300;
  }
  .seeking-a ~ .row .category {
    width: calc(25% - 0.5rem);
    flex: none;
  }

  .block {
    flex: 1 0 40%;
    max-width: calc(50% - 1em);

    &:nth-child(2n) {
      margin-left: 2rem;
    }

    &:only-child {
      max-width: 100%;
    }
  }
  .hidden + .block{
    margin-left: 0;
  }
  .row {
    flex: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .hidden {
    display: none;
  }
  ${Icon} {
    display: none;
  }
  ${media.phone`
    .block {
      flex: 100%;
      max-width: 100%;

      &:nth-child(2n) {
        margin-left: 0rem;
      }
    }
  `}

  ${media.tablet`
    .top {
      flex-direction: column;
    }
    .left, .right {
      flex: none;
      width: 500px;
      padding: 0;
      margin-left: auto;
      margin-right: auto;
    }

    .split .left, .split .right {
      max-width: none;
    }
    .left {
      margin-bottom: 5rem;
    }
  `}
  ${media.mobile`
    .seeking-a ~ .row .category {
      width: 100%;
    }
    .group-title {
      font-size: 2.2rem;
      margin-bottom: 2rem;
    }
    .split .half {
      max-width: 100%;
    }
    .category {
      font-size: 1.8rem;
    }
    .value {
      font-size: 2rem;
    }
  `}

  ${media.phone`
    .left {
      flex-direction: column;
      margin-bottom: 2rem;
    }
  `}
`

const MatchInfo = styled.div`
  .seeking-a {
    display: flex;
    flex-wrap: wrap;
    .row,
    .value {
      flex: 1 0 40%;
    }
    .value {
      max-width: calc(50% - 0.5rem);
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .category {
      min-width: calc(50% - 0.5rem);
    }
  }

  ${media.mobile`
    .row {
      flex-direction: column;
    }
    .seeking-a .value {
      max-width: none;
    }
    .category {
      width: 50%;
      margin-bottom: 0.5rem;
    }
  `}
`

const InfoDetails = styled.div`
  columns: 2;
  column-gap: 2rem;
  margin-bottom: 2rem;

  .row {
    display: flex;
    margin: 0 0 1.4rem;
  }

  .category,
  .value {
    display: inline-block;
    ${truncate('50%')}
    font-size: 1.4rem;
  }
  .category {
    color: ${colors.textSecondary};
    font-weight: 300;
  }

  ${media.mobile`
    columns: 1;
    margin: 0 auto;
    .category, .value {
      font-size: 2rem;
    }
  `}

  ${media.phone`
    width: 100%;

    .category {
      font-size: 1.6rem
    }
    .row {
      margin: 0 0 2rem;
    }
  `}
`

export default StyledUserProfile
export { InfoDetails, MatchInfo }
